import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { CloseOrganizationConfiguration } from './close-organization-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class CloseOrganizationModalService extends BaseModalService<CloseOrganizationConfiguration> {}
